export default __webpack_public_path__ + "static/media/card-blog17.91ba834d.jpg";